import {
  RideActionableCardSelector,
  RideRadioButton,
} from '@rimac-seguros/ride-system-components';
import { VariableSizeList as List } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import AutoSizer from 'react-virtualized-auto-sizer';

import React from 'react';

import './style.scss';

export const OptionsModal = ({
  name,
  options,
  onSelect,
  selected,
  virtualized,
  loadMoreItems,
  hasNextPage,
  smallText = false,
}) => {
  const itemCount = hasNextPage ? options.length + 1 : options.length;
  const isItemLoaded = index => !hasNextPage || index < options.length;

  const Row = ({ index, style }) => {
    if (!isItemLoaded(index)) {
      return <div style={style}>Loading...</div>;
    }
    const option = options[index];
    return (
      <div style={style}>
        <RideActionableCardSelector
          key={option?.value}
          className="modal-options-card modal-options-no-transform"
          onChange={(e) => onSelect(e.target?.value)}
          control={
            <RideRadioButton
              title={option?.label}
              name={name}
              defaultChecked={selected === String(option?.value)}
              value={option?.value}
              className="modal-with-search_option"
              showControl={false}
            />
          }
        >
          <div className="modal-with-search_option-label">
            <p>{option.label}</p>
          </div>
        </RideActionableCardSelector>
      </div>
    );
  };

  const getItemSize = index => {
    const option = options[index];
    if (option?.label?.length > 35) {
      return 96;
    }
    return 68;
  };

  return (
    <div className="modal-options h-full">
      {virtualized ? (
        <AutoSizer>
          {({ height, width }) => (
            <InfiniteLoader
              isItemLoaded={isItemLoaded}
              itemCount={itemCount}
              loadMoreItems={loadMoreItems}
            >
              {({ onItemsRendered, ref }) => (
                <List
                  height={height}
                  itemCount={itemCount}
                  itemSize={getItemSize}
                  width={width}
                  onItemsRendered={onItemsRendered}
                  ref={ref}
                >
                  {Row}
                </List>
              )}
            </InfiniteLoader>
          )}
        </AutoSizer>
      ) : (
        options?.map((option) => (
          <RideActionableCardSelector
            key={option?.value}
            className="modal-options-card modal-options-no-transform"
            onChange={(e) => onSelect(e.target?.value)}
            control={
              <RideRadioButton
                title={option?.label}
                name={name}
                defaultChecked={selected === String(option?.value)}
                value={option?.value}
                className="modal-with-search_option"
              />
            }
          >
            <div className={`modal-with-search_option-label ${smallText ? 'small-text' : ''}`}>
              <p>{option.label}</p>
            </div>
          </RideActionableCardSelector>
        ))
      )}
    </div>
  );
};
